<div class="grid">
  <div class="col-8 col-offset-2 md:col-6 md:col-offset-3">
    <p-card [header]="i18n?.i18nLng()['MENUGIROCODE']" class="h-full">
    </p-card>
  </div>
</div>
